// NaturePulse — Service Worker registration + update lifecycle.
// Registers /service-worker.js on load. Fires 'np:sw-update' when a new
// version is waiting so the app can offer an inline "Reload for latest data" chip.

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only in production builds (or when explicitly enabled) to avoid
  // caching stale bundles during hot-reload dev.
  const enableInDev = process.env.REACT_APP_ENABLE_SW === "1";
  if (process.env.NODE_ENV !== "production" && !enableInDev) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((registration) => {
      // If an update is found, notify the app when it's installed & waiting.
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent("np:sw-update", { detail: { registration } }));
          }
        });
      });
    }).catch(() => { /* SW is optional — fail silently */ });

    // If a new SW takes control while the app is open, force a reload once.
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function skipWaitingAndReload() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistration().then((registration) => {
    const waiting = registration?.waiting;
    if (waiting) waiting.postMessage("SKIP_WAITING");
    else window.location.reload();
  });
}
